<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title
      :title="{ name: '备用金管理', path: '/system/pettyCash/all' }"
    ></Title>

    <div style="margin: 10px auto">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px">
          <el-col :span="6">
            <el-input
              v-model="qparam.applyUserName"
              placeholder="申请人"
            ></el-input>
          </el-col>

          <el-col :span="5">
            <el-input
                v-model="qparam.remark"
                placeholder="申请用途"
            ></el-input>
          </el-col>

          <el-col :span="9">
            <el-date-picker
              style=""
              v-model="applyTime"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-col>
          <el-col
            :span="5"
            style="float: right; margin-left: 10px; margin-top: 10px"
          >
            <el-button
              icon="el-icon-refresh-left"
              type="primary"
              @click="resetQparam"
              >重置
            </el-button>
            <el-button icon="el-icon-search" type="primary" @click="search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-card>
    </div>

    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column width="160px" prop="userName" label="申请人">
          </el-table-column>

          <el-table-column width="120px" prop="type" label="申请类型">
            <template slot-scope="scope">
              <div v-for="(row, i) in typeData" :key="i">
                <el-tag v-if="row.typeId === scope.row.type" type="success">
                  {{ row.typeName }}
                </el-tag>
              </div>
            </template>
          </el-table-column>

          <el-table-column width="200px" prop="amount" label="申请金额">
          </el-table-column>
          <el-table-column prop="remark" label="申请用途">
          </el-table-column>
          <el-table-column width="200px" prop="applyTime" label="申请时间">
          </el-table-column>

          <el-table-column width="260px" label="操作">
            <template v-slot="scope">
              <el-button size="mini" @click="handleDetail(scope.row)">查看</el-button>
              <el-button size="mini" type="primary" @click="handlePrint(scope.row)">打印</el-button>
              <el-button size="mini" type="primary" @click="handleCustomPrint(scope.row)">自定义打印</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 40px auto; width: 30%">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentPageChangeEvent"
            :current-page="qparam.current"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements"
          >
          </el-pagination>
        </div>
      </el-card>
      <el-dialog
      title="备用金信息"
      :visible.sync="projectShow"
      width="1200px"
      top="6vh">
      <PettyCashDetailDialog
       :key="uuid"
       :applyId="applyId"
       :applyServiceId="applyServiceId"
       :applyType="applyType"
       :role="1 || 4" ></PettyCashDetailDialog>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "@/components/Title";
import {requestAllPettyCashApply, requestPrintPettyCash} from "@/api"
import {uuid,AesDecrypt} from "@/util";
import PettyCashDetailDialog from "@/components/item/common/PettyCashDetailsDialog.vue";

export default {
  name: "AllPettyCashApply",
  components: {Title, PettyCashDetailDialog},
  
  data() {
    return {
      uuid: "",
      hasAllRole: false,
      applyId: "",
      applyServiceId: "",
      applyType: "",
      projectShow: false,
      applyTime: [],
      tableData: [],
      totalElements: 0,
      qparam: {
          current: 1,
          size: 10,
          applyUserName: "",
          remark: "",
          startTime: "",
          endTime: "",
      },
      user: {},
      typeData: [
        { typeId:1,typeName:"项目费用"},
        { typeId:2,typeName:"管理费用"}
      ],
    }
  },
  computed: {
    ...mapState(["flowData"]),
  },
  created() {
    let data = AesDecrypt(window.localStorage.getItem("user"));
    this.user = JSON.parse(data);
    this.initTableData()
  },

  methods: {
    async initTableData() {
      this.qparam.startTime = this.applyTime[0]
      this.qparam.endTime = this.applyTime[1]
      const hasAllRole = this.user.roles.includes(1) || this.user.roles.includes(4)
      if (hasAllRole) {
        const res = await requestAllPettyCashApply(this.qparam);
        if (res.code === 200) {
          this.totalElements = res.total
          this.tableData = res.rows
          let data = this.tableData
          this.tableData = data
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.initTableData()
    },
    resetQparam() {
      this.applyTime = []
      this.qparam.applyUserName = ""
      this.qparam.remark = ""
      this.initTableData()
    },
    currentPageChangeEvent(currentPage) {
      this.qparam.current = currentPage;
      this.initTableData()
    },
    async search() {
      this.qparam.current = 1
      this.qparam.size = 10
      await this.initTableData()
    },
    handleDetail(row) {
      this.projectShow = true
      this.applyId = row.applyId
      this.applyServiceId = row.applyServiceId
      this.applyType = row.applyType
      this.uuid = uuid()
    },
    handlePrint(row){
      requestPrintPettyCash({ pettyCashId: row.applyServiceId,type:1 }).then(
          (res) => {
            if (res.code === 200) {
              window.location.href = res.object;
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          }
      );
    },
    handleCustomPrint(row){
      requestPrintPettyCash({ pettyCashId: row.applyServiceId,type:2 }).then(
          (res) => {
            if (res.code === 200) {
              window.location.href = res.object;
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          }
      );
    }
  }
}
</script>

<style>
.paybackInfo {
  display: flex;
}
.paybackInfo-btn {
  margin-left: 12px;
  cursor: pointer;
  color: #409eff;
}

.low {
  /*  color: #f56c6c;*/
  color: red;
}
.middle {
  color: #e6a23c;
}
.height {
  /*  color: #5cb87a;*/
  color: green;
}
</style>

<style scoped>
.tags-container {
  display: flex;
  flex-wrap: wrap;
}

.tag-item {
  margin-right: 8px; /* tag 之间的间距 */
  margin-bottom: 8px; /* 换行时的间距 */
}

.pettyCash-type-column .el-tag {
  display: inline-block; /* 确保 tag 作为行内块元素显示 */
}
</style>
